module.exports = __webpack_public_path__ + "static/media/YF17_4.a9f02f1b.jpg";